export default "__VITE_ASSET__D43QwG6d__"